/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AtivarDelegacaoTarefasFormDto } from '../models/ativar-delegacao-tarefas-form-dto';
import { AtribuirTarefaFormDto } from '../models/atribuir-tarefa-form-dto';
import { BaseCriteriaDto } from '../models/base-criteria-dto';
import { CompletarTarefaFormDto } from '../models/completar-tarefa-form-dto';
import { DelegacaoTarefasCriteriaDto } from '../models/delegacao-tarefas-criteria-dto';
import { DelegacaoTarefasDto } from '../models/delegacao-tarefas-dto';
import { DelegacaoTarefasPageDto } from '../models/delegacao-tarefas-page-dto';
import { DesativarDelegacaoTarefasFormDto } from '../models/desativar-delegacao-tarefas-form-dto';
import { TarefaCriteriaDto } from '../models/tarefa-criteria-dto';
import { TarefaDto } from '../models/tarefa-dto';
import { TarefaHistoricoDto } from '../models/tarefa-historico-dto';
import { TarefaPageDto } from '../models/tarefa-page-dto';


/**
 * Tarefas
 */
@Injectable({
  providedIn: 'root',
})
export class TarefasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTarefas
   */
  static readonly GetTarefasPath = '/tarefas';

  /**
   * Pesquisar Tarefas Page.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTarefas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTarefas$Response(params?: {
    criteria?: TarefaCriteriaDto;
  }): Observable<StrictHttpResponse<TarefaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.GetTarefasPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaPageDto>;
      })
    );
  }

  /**
   * Pesquisar Tarefas Page.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTarefas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTarefas(params?: {
    criteria?: TarefaCriteriaDto;
  }): Observable<TarefaPageDto> {

    return this.getTarefas$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaPageDto>) => r.body as TarefaPageDto)
    );
  }

  /**
   * Path part for operation getTarefa
   */
  static readonly GetTarefaPath = '/tarefas/{id}';

  /**
   * Pesquisar Tarefas por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTarefa()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTarefa$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<TarefaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.GetTarefaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaDto>;
      })
    );
  }

  /**
   * Pesquisar Tarefas por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTarefa$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTarefa(params: {
    id: string;
  }): Observable<TarefaDto> {

    return this.getTarefa$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaDto>) => r.body as TarefaDto)
    );
  }

  /**
   * Path part for operation getTarefaAnterior
   */
  static readonly GetTarefaAnteriorPath = '/tarefas/{id}/anterior';

  /**
   * Obter o detalhe da tarefa anterior à tarefa indicada.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTarefaAnterior()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTarefaAnterior$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<TarefaHistoricoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.GetTarefaAnteriorPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaHistoricoDto>;
      })
    );
  }

  /**
   * Obter o detalhe da tarefa anterior à tarefa indicada.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTarefaAnterior$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTarefaAnterior(params: {
    id: string;
  }): Observable<TarefaHistoricoDto> {

    return this.getTarefaAnterior$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaHistoricoDto>) => r.body as TarefaHistoricoDto)
    );
  }

  /**
   * Path part for operation atribuirTarefa
   */
  static readonly AtribuirTarefaPath = '/tarefas/{id}/atribuir';

  /**
   * Atribuir Tarefas por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `atribuirTarefa()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  atribuirTarefa$Response(params: {
    id: string;
    body?: AtribuirTarefaFormDto
  }): Observable<StrictHttpResponse<TarefaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.AtribuirTarefaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaDto>;
      })
    );
  }

  /**
   * Atribuir Tarefas por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `atribuirTarefa$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  atribuirTarefa(params: {
    id: string;
    body?: AtribuirTarefaFormDto
  }): Observable<TarefaDto> {

    return this.atribuirTarefa$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaDto>) => r.body as TarefaDto)
    );
  }

  /**
   * Path part for operation completarTarefa
   */
  static readonly CompletarTarefaPath = '/tarefas/{id}/completar';

  /**
   * Completar Tarefas por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `completarTarefa()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completarTarefa$Response(params: {
    id: string;
    body?: CompletarTarefaFormDto
  }): Observable<StrictHttpResponse<TarefaHistoricoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.CompletarTarefaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaHistoricoDto>;
      })
    );
  }

  /**
   * Completar Tarefas por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `completarTarefa$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completarTarefa(params: {
    id: string;
    body?: CompletarTarefaFormDto
  }): Observable<TarefaHistoricoDto> {

    return this.completarTarefa$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaHistoricoDto>) => r.body as TarefaHistoricoDto)
    );
  }

  /**
   * Path part for operation libertarTarefa
   */
  static readonly LibertarTarefaPath = '/tarefas/{id}/libertar';

  /**
   * Libertar Tarefas por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `libertarTarefa()` instead.
   *
   * This method doesn't expect any request body.
   */
  libertarTarefa$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<TarefaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.LibertarTarefaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaDto>;
      })
    );
  }

  /**
   * Libertar Tarefas por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `libertarTarefa$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  libertarTarefa(params: {
    id: string;
  }): Observable<TarefaDto> {

    return this.libertarTarefa$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaDto>) => r.body as TarefaDto)
    );
  }

  /**
   * Path part for operation reclamarTarefa
   */
  static readonly ReclamarTarefaPath = '/tarefas/{id}/reclamar';

  /**
   * Reclamar Tarefas por Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reclamarTarefa()` instead.
   *
   * This method doesn't expect any request body.
   */
  reclamarTarefa$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<TarefaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.ReclamarTarefaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaDto>;
      })
    );
  }

  /**
   * Reclamar Tarefas por Id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reclamarTarefa$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reclamarTarefa(params: {
    id: string;
  }): Observable<TarefaDto> {

    return this.reclamarTarefa$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaDto>) => r.body as TarefaDto)
    );
  }

  /**
   * Path part for operation getTarefaAtualPedido
   */
  static readonly GetTarefaAtualPedidoPath = '/tarefas/pedido/{id}';

  /**
   * Tarefa atual do pedido.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTarefaAtualPedido()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTarefaAtualPedido$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TarefaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.GetTarefaAtualPedidoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaDto>;
      })
    );
  }

  /**
   * Tarefa atual do pedido.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTarefaAtualPedido$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTarefaAtualPedido(params: {
    id: number;
  }): Observable<TarefaDto> {

    return this.getTarefaAtualPedido$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaDto>) => r.body as TarefaDto)
    );
  }

  /**
   * Path part for operation getDelegacaoTarefas
   */
  static readonly GetDelegacaoTarefasPath = '/tarefas/delegacao';

  /**
   * Pesquisar Tarefas Delegacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDelegacaoTarefas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDelegacaoTarefas$Response(params?: {
    desativarDelegacaoTarefasFormDto?: DelegacaoTarefasCriteriaDto;
  }): Observable<StrictHttpResponse<DelegacaoTarefasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.GetDelegacaoTarefasPath, 'get');
    if (params) {
      rb.query('desativarDelegacaoTarefasFormDto', params.desativarDelegacaoTarefasFormDto, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DelegacaoTarefasPageDto>;
      })
    );
  }

  /**
   * Pesquisar Tarefas Delegacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDelegacaoTarefas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDelegacaoTarefas(params?: {
    desativarDelegacaoTarefasFormDto?: DelegacaoTarefasCriteriaDto;
  }): Observable<DelegacaoTarefasPageDto> {

    return this.getDelegacaoTarefas$Response(params).pipe(
      map((r: StrictHttpResponse<DelegacaoTarefasPageDto>) => r.body as DelegacaoTarefasPageDto)
    );
  }

  /**
   * Path part for operation getDelegacaoTarefasById
   */
  static readonly GetDelegacaoTarefasByIdPath = '/tarefas/delegacao/{id}';

  /**
   * Pesquisar Tarefas Delegacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDelegacaoTarefasById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDelegacaoTarefasById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<DelegacaoTarefasDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.GetDelegacaoTarefasByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DelegacaoTarefasDto>;
      })
    );
  }

  /**
   * Pesquisar Tarefas Delegacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDelegacaoTarefasById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDelegacaoTarefasById(params: {
    id: string;
  }): Observable<DelegacaoTarefasDto> {

    return this.getDelegacaoTarefasById$Response(params).pipe(
      map((r: StrictHttpResponse<DelegacaoTarefasDto>) => r.body as DelegacaoTarefasDto)
    );
  }

  /**
   * Path part for operation ativarDelegacaoTarefas
   */
  static readonly AtivarDelegacaoTarefasPath = '/tarefas/delegacao/ativar';

  /**
   * Pesquisar Tarefas Delegacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarDelegacaoTarefas()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ativarDelegacaoTarefas$Response(params?: {
    body?: AtivarDelegacaoTarefasFormDto
  }): Observable<StrictHttpResponse<DelegacaoTarefasDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.AtivarDelegacaoTarefasPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DelegacaoTarefasDto>;
      })
    );
  }

  /**
   * Pesquisar Tarefas Delegacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarDelegacaoTarefas$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ativarDelegacaoTarefas(params?: {
    body?: AtivarDelegacaoTarefasFormDto
  }): Observable<DelegacaoTarefasDto> {

    return this.ativarDelegacaoTarefas$Response(params).pipe(
      map((r: StrictHttpResponse<DelegacaoTarefasDto>) => r.body as DelegacaoTarefasDto)
    );
  }

  /**
   * Path part for operation desativarDelegacaoTarefas
   */
  static readonly DesativarDelegacaoTarefasPath = '/tarefas/delegacao/desativar';

  /**
   * Pesquisar Tarefas Delegacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarDelegacaoTarefas()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  desativarDelegacaoTarefas$Response(params?: {
    body?: DesativarDelegacaoTarefasFormDto
  }): Observable<StrictHttpResponse<DelegacaoTarefasDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.DesativarDelegacaoTarefasPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DelegacaoTarefasDto>;
      })
    );
  }

  /**
   * Pesquisar Tarefas Delegacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarDelegacaoTarefas$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  desativarDelegacaoTarefas(params?: {
    body?: DesativarDelegacaoTarefasFormDto
  }): Observable<DelegacaoTarefasDto> {

    return this.desativarDelegacaoTarefas$Response(params).pipe(
      map((r: StrictHttpResponse<DelegacaoTarefasDto>) => r.body as DelegacaoTarefasDto)
    );
  }

  /**
   * Path part for operation getHistoricoTarefasPedido
   */
  static readonly GetHistoricoTarefasPedidoPath = '/tarefas/historico/{idPedido}';

  /**
   * Pesquisar Histórico de Tarefas de um Pedido.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHistoricoTarefasPedido()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHistoricoTarefasPedido$Response(params: {
    idPedido: number;
  }): Observable<StrictHttpResponse<Array<TarefaHistoricoDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.GetHistoricoTarefasPedidoPath, 'get');
    if (params) {
      rb.path('idPedido', params.idPedido, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TarefaHistoricoDto>>;
      })
    );
  }

  /**
   * Pesquisar Histórico de Tarefas de um Pedido.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHistoricoTarefasPedido$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHistoricoTarefasPedido(params: {
    idPedido: number;
  }): Observable<Array<TarefaHistoricoDto>> {

    return this.getHistoricoTarefasPedido$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TarefaHistoricoDto>>) => r.body as Array<TarefaHistoricoDto>)
    );
  }

  /**
   * Path part for operation getDeferimentosValidarPropostaDecisao
   */
  static readonly GetDeferimentosValidarPropostaDecisaoPath = '/tarefas/validarPropostaDecisao/deferimentos';

  /**
   * Pesquisar Deferimentos Validar Proposta Decisão.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeferimentosValidarPropostaDecisao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeferimentosValidarPropostaDecisao$Response(params?: {
    criteriaDto?: BaseCriteriaDto;
  }): Observable<StrictHttpResponse<TarefaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.GetDeferimentosValidarPropostaDecisaoPath, 'get');
    if (params) {
      rb.query('criteriaDto', params.criteriaDto, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TarefaPageDto>;
      })
    );
  }

  /**
   * Pesquisar Deferimentos Validar Proposta Decisão.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDeferimentosValidarPropostaDecisao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeferimentosValidarPropostaDecisao(params?: {
    criteriaDto?: BaseCriteriaDto;
  }): Observable<TarefaPageDto> {

    return this.getDeferimentosValidarPropostaDecisao$Response(params).pipe(
      map((r: StrictHttpResponse<TarefaPageDto>) => r.body as TarefaPageDto)
    );
  }

  /**
   * Path part for operation confirmarPropostasDeferimento
   */
  static readonly ConfirmarPropostasDeferimentoPath = '/tarefas/validarPropostaDecisao/deferimentos';

  /**
   * Confirmar todas as propostas de deferimento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmarPropostasDeferimento()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirmarPropostasDeferimento$Response(params?: {
    body?: Array<string>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TarefasService.ConfirmarPropostasDeferimentoPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Confirmar todas as propostas de deferimento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `confirmarPropostasDeferimento$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirmarPropostasDeferimento(params?: {
    body?: Array<string>
  }): Observable<void> {

    return this.confirmarPropostasDeferimento$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
